import * as Constants from "../constants";

let animalItemTypes = [Constants.ITEM_TYPE_BOOK_RECORD_ANIMAL, Constants.ITEM_TYPE_COLLECTIVE_HUNTING_ANIMAL];

export const getItemName = item => {
    if(isAnimalItem(item)) {
        if(item.identifier && item.identifier.length > 0) {
            return item.name + ` (${item.identifier})`;
        }
    }

    return item.name;
}

export const getItemUnit = (item, priceListType) => {
    if(isAnimalItem(item)) {
        if(parseInt(priceListType) === Constants.PRICE_LIST_REGULAR) {
            return 'kg';
        }

        return 'szt';
    }

    return item.unit;
}

export const getItemQuantity = (item, priceListType) => {
    if(isAnimalItem(item)) {
        if (parseInt(priceListType) === Constants.PRICE_LIST_REGULAR) {
            return parseFloat(item.quantity) * parseFloat(item.weight);
        }
    }

    return item.quantity;
}

export const isAnimalItem = item => {
    if (typeof item.type != 'undefined') {
        if (animalItemTypes.includes(item.type)) {
            return true;
        }
    }

    return false;
}
